module.exports = __webpack_public_path__ + "img/galery-smart-scan-2.ce81f962.png";